import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assemblyPagination: { skip: 0, limit: 30 },
  devicesPagination: { skip: 0, limit: 30 },
  firmwarePagination: { skip: 0, limit: 30 },
  workOrderPagination: { skip: 0, limit: 10 }
};

const paginationSlice = createSlice({
  name: "pagination",
  initialState: initialState,
  reducers: {
    setAssembliesPagination: (state, action) => {
      state.assemblyPagination = action.payload;
    },
    setDevicesPagination: (state, action) => {
      state.devicesPagination = action.payload;
    },
    setFirmwarePagination: (state, action) => {
      state.firmwarePagination = action.payload;
    },
    setWorkOrderPagination: (state, action) => {
      state.workOrderPagination = action.payload
    },
    clearAssembliesPagination: (state, _action) => {
      state.assemblyPagination = { skip: 0, limit: 30 };
    },
    clearDevicesPagination: (state, _action) => {
      state.devicesPagination = { skip: 0, limit: 30 };
    },
    clearFirmwarePagination: (state, _action) => {
      state.firmwarePagination = { skip: 0, limit: 30 };
    },
    clearWorkOrderPagination: (state, action) => {
      state.workOrderPagination = { skip: 0, limit: 10 }
    }
  },
});

export const {
  setAssembliesPagination,
  setDevicesPagination,
  setFirmwarePagination,
  setWorkOrderPagination,
  clearAssembliesPagination,
  clearDevicesPagination,
  clearFirmwarePagination,
  clearWorkOrderPagination,
} = paginationSlice.actions;
export default paginationSlice.reducer;
